export const category = 'CreateBabyRegistry';
export const CREATE_CTA = 'CreateBabyRegistryCTA';
export const CREATE_BABY_REGISTRY_APP_NAME = 'createbabyregistry';
